import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';

/**
 * Dropdown de seleção com busca local, usado pelos níveis de hierarquia do
 * context-selector-modal (Entidade/Servidor/Ano letivo/Estabelecimento/Turma).
 * Cobre só a parte 100% comum aos 5 — mensagens específicas de cada nível
 * (ex.: "vinculado automaticamente", "identificando servidor...") continuam
 * no componente pai, fora deste.
 */
@Component({
  selector: 'app-hierarquia-select',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule],
  templateUrl: './hierarquia-select.component.html'
})
export class HierarquiaSelectComponent {
  @Input() label = '';
  @Input() buttonText = 'Selecione...';
  @Input() buttonTextMuted = false;
  @Input() options: any[] = [];
  @Input() getOptionId: (opt: any) => number | null = (opt) => opt?.id ?? null;
  @Input() getOptionLabel: (opt: any) => string = (opt) => opt?.nome ?? '';
  @Input() selectedId: number | null = null;
  @Input() isOpen = false;
  @Input() disabled = false;
  @Input() hideClear = false;
  @Input() searchTerm = '';
  @Input() searchPlaceholder = 'Buscar...';
  @Input() noResultsText = 'Nenhum resultado encontrado';

  @Output() toggleRequested = new EventEmitter<void>();
  @Output() searchTermChange = new EventEmitter<string>();
  @Output() searchChanged = new EventEmitter<string>();
  @Output() searchCleared = new EventEmitter<void>();
  @Output() optionSelected = new EventEmitter<any>();
  @Output() clearRequested = new EventEmitter<void>();

  onToggle(): void {
    this.toggleRequested.emit();
  }

  onSearchModelChange(valor: string): void {
    this.searchTermChange.emit(valor);
    this.searchChanged.emit(valor);
  }

  onClearSearch(): void {
    this.searchTermChange.emit('');
    this.searchCleared.emit();
  }

  onSelect(option: any): void {
    this.optionSelected.emit(option);
  }

  onClear(): void {
    this.clearRequested.emit();
  }
}
